module.exports = __webpack_public_path__ + "img/qu_jp.a0823f8.jpg";